import React from 'react';
import PropTypes from 'prop-types';
import { Button, FontIcon } from 'react-md';
import './LoaderButton.css';

const LoaderButton = ({
  isLoading,
  text,
  loadingText,
  className = '',
  disabled = false,
  ...props
}) => (
  <Button
    className={`LoaderButton ${className}`}
    disabled={disabled || isLoading}
    {...props}
  >
    {isLoading && <FontIcon className="spinning" >refresh</FontIcon>}
    {!isLoading ? text : loadingText}
  </Button>
);

LoaderButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  text: PropTypes.string,
  loadingText: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};


export default LoaderButton;



// WEBPACK FOOTER //
// ./src/components/LoaderButton.js